import { useNavigate } from "react-router"
import { LeftArrow } from "../../icons/arrows/leftArrow"
import { getCarIconsFn, postCarIconsFn } from "../../transactions/serviceBooking/serviceBooking";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import clsx from "clsx";
import { TooltipComponent } from "../../components/ui/Tooltip";
import { DownIcon, InfoIcon } from "../../icons";
import { Button } from "../../components/ui/Button";
import Loader from "../../components/elements/loader";

export const NotificationsGuide = () => {
    const [selectedIcons, setSelectedIcons] = useState([])
    const [loading,setLoading] = useState(false)
    const [message, setMessage] = useState();
    const [expand, setExpand] = useState(false)
    const navigate = useNavigate();

    const { data, isFetching } = useQuery({
        queryKey: [],
        queryFn: getCarIconsFn,
    })

    const mutation = useMutation({
        mutationFn: (carIcons) => postCarIconsFn(carIcons),
        onSettled: (data, error, variables, context) => {
            setLoading(false)
          setMessage(data.data.systemAction)
          }
    })

    const handleSelection = (id) => {
        let updatedList = [...selectedIcons];
        const isSelected = selectedIcons.findIndex(select => select === id);
        if (isSelected === -1) {
           updatedList.push(id)
        } else {
            updatedList.splice(isSelected, 1)
        }
        setSelectedIcons(updatedList)
    }
    
    const handleSubmit = (list) => {
        if (message !== undefined && list === undefined) {
            setMessage()
            setSelectedIcons([])
        }
        else {
            setLoading(true)
            if (list) {
                mutation.mutate(list);
            } else {
                mutation.mutate(selectedIcons);
            }
        }
    }

    return (
       
            <div className="flex items-center flex-col gap-5 container mx-auto h-fit" style={{ minHeight: 'calc(100vh - 140px)' }}>
                <div className="flex gap-2 items-center w-full pt-6">
                    <LeftArrow className={'cursor-pointer'} onClick={()=>{navigate('/service-booking')}}/>
                    <p className="h3">Οδηγός Ενδείξεων</p>
                </div>
                <div className="flex w-full gap-6 mb-6">
                    <div className="flex flex-col gap-8 w-full lg:w-fit">
                        <div className="p-6 bg-[#F5F5F7] rounded-[20px] flex flex-col gap-3 max-lg:hidden">
                            <h4>Oδηγίες</h4>
                            <div className="text-body-large">
                                <p className="text-body">• Θέσε τον κινητήρα σε λειτουργία.</p>
                                <p  className="text-body">• Περίμενε για 30 δευτερόλεπτα.</p>
                                <p  className="text-body">• Από τον παρακάτω πίνακα, επίλεξε τα εικονίδια που εμφανίζονται στον πίνακα οργάνων του αυτοκινήτου.</p>
                            </div>
                        </div>
                        <div className="flex flex-col gap-8 max-lg:hidden">
                            <h4>Επίλεξε την ένδειξη που εμφανίζεται</h4>
                        <div className="w-fit grid grid-cols-6 gap-3 lg:gap-5 items-center">
                                {isFetching && Array.from({ length: 9 }, (_, index) => (
                                    <div
                                    key={index}
                                    className={
                                        'p-3 animate-pulse bg-powdergrey flex w-full items-center gap-3 rounded-lg'
                                    }
                                    >
                                    <div className={'rounded-full bg-powdergrey w-10 h-10 leading-10'} />
                                    </div>
                                ))}
                                {data && data.data.map(item =>
                                    <TooltipComponent content={item.label}>
                                        <img alt='' width={60} onClick={() => {message === undefined && handleSelection(item.id)}} key={item.id} className={clsx("rounded-[6px] cursor-pointer border border-2",selectedIcons.find(select => select === item.id) !== undefined ? 'border-[#FF0000]' : 'border-transparent')} src={item.url} />
                                    </TooltipComponent>
                                )}
                            </div>
                            <p className="text-[#6A6A6A] text-disclaimer">Αν δεν βλέπεις τη λυχνία παραπάνω πάτησε
                                <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(['other-red'])}> εδώ </span>
                                για κόκκινη ένδειξη και
                                <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(["other-yellow-orange"])}> εδώ </span>
                                για κίτρινη ή πορτοκαλί ένδειξη.
                            </p>
                        </div>
                    {message !== undefined ?
                        <div className="bg-white mt-20 h-[400px] rounded-[12px] flex flex-col gap-6 items-center justify-center p-10 lg:hidden">
                                <InfoIcon className={'w-10 h-10 text-[#D4002A]'} />
                                <p className="text-center text-body-large">{message === undefined ? 'Επίλεξε μία από τις ενδείξεις αριστερά για περισσότερες λεπτομέρειες' : message.label}</p>
                                {message && message.phone && <h4>{message.phone}</h4>}
                        </div>:
                         <div className="flex flex-col gap-8 lg:hidden">
                         <h4>Επίλεξε την ένδειξη που εμφανίζεται</h4>
                         <div className="lg:w-fit grid grid-cols-6 gap-3 lg:gap-5 items-center">
                             {data && data.data.map(item =>
                                 <TooltipComponent content={item.label}>
                                     <img alt='' width={60} onClick={() => {message === undefined && handleSelection(item.id)}} key={item.id} className={clsx("rounded-[6px] cursor-pointer border border-2",selectedIcons.find(select => select === item.id) !== undefined ? 'border-[#FF0000]' : 'border-transparent')} src={item.url} />
                                 </TooltipComponent>
                             )}
                         </div>
                         <p className="text-[#6A6A6A] text-disclaimer">Αν δεν βλέπεις την λυχνία παραπάνω πάτησε
                                <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(['other-red'])}> εδώ </span>
                                για κόκκινη ένδειξη και
                                <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(["other-yellow-orange"])}> εδώ </span>
                                για κίτρινη ή πορτοκαλί ένδειξη.
                         </p>
                     </div>
                        }
                    </div>
                    <div className="w-[626px] rounded-[12px] border border-[#A5A5A5] flex flex-col gap-6 items-center justify-center p-10 max-lg:hidden">
                        <InfoIcon className={'w-12 h-12'} />
                        <p className="text-center text-body-large">{message === undefined ? 'Επίλεξε μία από τις ενδείξεις αριστερά για περισσότερες λεπτομέρειες' : message.label}</p>
                        {message && message.phone && <h4>{message.phone}</h4>}
                    <Button disabled={selectedIcons.length === 0} className={'disabled:bg-[#A5A5A5] text-white bg-[#D4002A] py-3 px-14 rounded-[6px] leading-[16px]'} onClick={() => { handleSubmit() }}>{message === undefined ? 'Υποβολή' : 'Επιστροφή'}</Button>
                    {loading && <Loader />}
                </div>
            </div>
            <div className="fixed bottom-0 w-full lg:hidden">
                {message === undefined && <div className="bg-white rounded-t-[12px] transition-all duration-500 ease-in" style={{
                    boxShadow: '0px -8px 10px 0px #0000000D'
                }}>
                    <div className="flex w-full justify-between p-3">
                        <h4>Oδηγίες</h4>
                        <DownIcon
                            onClick={() => {
                                setExpand(!expand);
                            }}
                            className={clsx('hover:cursor-pointer', !expand && 'rotate-180')}
                        />
                    </div>
                    {expand &&
                        <div className="text-body-large p-3">
                                                            <p className="text-body">• Θέσε τον κινητήρα σε λειτουργία.</p>
                                <p  className="text-body">• Περίμενε για 30 δευτερόλεπτα.</p>
                                <p  className="text-body">• Από τον παρακάτω πίνακα, επίλεξε τα εικονίδια που εμφανίζονται στον πίνακα οργάνων του αυτοκινήτου.</p>
                        </div>
                    }
                </div>
                }
                    <div className="bg-white border-t border-[#A5A5A5] pt-6 pb-10 px-5 w-full">
                        <Button disabled={selectedIcons.length === 0} className={'disabled:bg-[#A5A5A5] text-white bg-[#D4002A] py-3 w-full rounded-[6px] leading-[16px]'} onClick={() => { handleSubmit() }}>{message === undefined ? 'Υποβολή': 'Επιστροφή' }</Button>
                    </div>
                </div>
            </div>
    )
}